import { lazy } from 'react';

const MeterpointValidationContent = import(
  'components/direct-sales/meterpoint-validation/components/MeterPointValidationContent'
);

const MeterpointValidationHeader = import(
  'components/direct-sales/meterpoint-validation/components/MeterPointValidationHeader'
);

const MeterpointValidationFooter = import(
  'components/direct-sales/energy-needs/components/EnergyNeedsFooter'
);

const MeterpointValidation = {
  Content: lazy(() => MeterpointValidationContent),
  Header: lazy(() => MeterpointValidationHeader),
  Footer: lazy(() => MeterpointValidationFooter)
};

export default MeterpointValidation;
